import React, { createContext, useContext, useEffect, useState } from "react";
import { useUserSessionContext } from "./UserSessionContext";

export enum RouteEnum {
  HOME = "home",
  SIGN_IN = "sign-in",
  OTR_SEARCH = "otr-search",
  DRAYAGE_SEARCH = "drayage-search",
}

interface RouteContextType {
  currentRoute: RouteEnum;
  navigate: (route: RouteEnum) => void;
}

const RouteContext = createContext<RouteContextType | null>(null);

const RouteProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isLoggedIn } = useUserSessionContext();

  const [currentRoute, setCurrentRoute] = useState<RouteEnum>(
    isLoggedIn ? RouteEnum.DRAYAGE_SEARCH : RouteEnum.HOME,
  );

  const navigate = (route: RouteEnum) => {
    setCurrentRoute(route);
  };

  useEffect(() => {
    if (!isLoggedIn) {
      setCurrentRoute(RouteEnum.HOME);
    }
  }, [isLoggedIn]);

  return (
    <RouteContext.Provider value={{ currentRoute, navigate }}>
      {children}
    </RouteContext.Provider>
  );
};

export const useRoute = () => {
  const context = useContext(RouteContext);

  if (!context) {
    throw new Error("useRoute must be used within a RouteProvider");
  }

  return context;
};

export default RouteProvider;
